import { render, staticRenderFns } from "./ValSectoresNew.vue?vue&type=template&id=5cfec4f6&"
import script from "./ValSectoresNew.vue?vue&type=script&lang=js&"
export * from "./ValSectoresNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports